import constants from '../constants.js';

const RailStationsSuppliersCode = {
  displayName: 'Code',
  dataAt: 'Suppliers.$railStationSup.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailStationsSuppliersSupplier = {
  displayName: 'Supplier',
  dataAt: 'Suppliers.$railStationSup.Supplier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailStationsSuppliersItem = {
  displayName: 'Suppliers',
  dataAt: 'Suppliers.$railStationSup',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [RailStationsSuppliersSupplier, RailStationsSuppliersCode],
  endpoint: 'RailStations',
  routeParamId: 'railStationId',
  removeParamId: 'railStationSup',
  canDelete: true
};

const RailStationsSuppliers = {
  displayName: 'Suppliers',
  dataAt: 'Suppliers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: RailStationsSuppliersItem,
  gridCols:
    [{name: 'Supplier', key: 'Supplier'},
      {name: 'Code', key: 'Code'}]
};

const RailStationsIsDeleted = {
  displayName: 'Deleted',
  dataAt: 'IsDeleted',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const RailStationsUtcOffsetHours = {
  displayName: 'UTC Offset Hours',
  dataAt: 'UtcOffsetHours',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: 0,
  max: 12,
  default: 0,
  required: true
};

const RailStationsTimeZoneRegionName = {
  displayName: 'Time Zone Region Name',
  dataAt: 'TimeZoneRegionName',
  displayAs: constants.DISPLAY_AS.TIME_ZONE_SELECT,
  selectType: 'single',
  required: true
};

const RailStationsLatitude = {
  displayName: 'Latitude',
  dataAt: 'Latitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999,
  required: true
};

const RailStationsLongitude = {
  displayName: 'Longitude',
  dataAt: 'Longitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999,
  required: true
};

const RailStationsIata = {
  displayName: 'IATA',
  dataAt: 'Iata',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const RailStationsCountryName = {
  displayName: 'CountryCode',
  dataAt: 'CountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single',
  required: true
};

const RailStationsCode = {
  displayName: 'Code',
  dataAt: 'Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const RailStationsCityName = {
  displayName: 'City Name',
  dataAt: 'CityName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const RailStationsCityLongitude = {
  displayName: 'City Longitude',
  dataAt: 'CityLongitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999,
  required: true
};

const RailStationsCityLatitude = {
  displayName: 'City Latitude',
  dataAt: 'CityLatitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999,
  required: true
};

const RailStationsCityCode = {
  displayName: 'City Code',
  dataAt: 'CityCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const RailStationsName = {
  displayName: 'Name',
  dataAt: 'Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const RailStationsId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const RailStationsNameLabel = {dataAt: 'Name', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Name:'};

const RailStationsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Rail Stations',
  data:
    {
      Name: '',
      CityCode: '',
      CityLatitude: 0,
      CityLongitude: 0,
      CityName: '',
      Code: '',
      CountryCode: '',
      CountryName: '',
      Iata: '',
      Latitude: 0,
      Longitude: 0,
      IsDeleted: false,
      Suppliers: []
    },
  dataAt: '',
  children: [RailStationsName, RailStationsCityCode, RailStationsCityLatitude, RailStationsCityLongitude, RailStationsCityName, RailStationsCode, RailStationsCountryName, RailStationsIata, RailStationsLongitude, RailStationsLatitude, RailStationsTimeZoneRegionName, RailStationsUtcOffsetHours],
  endpoint: 'RailStations'
};

const RailStationsResource = {
  displayName: 'Rail Stations',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [RailStationsNameLabel, RailStationsId, RailStationsName, RailStationsCityCode, RailStationsCityLatitude, RailStationsCityLongitude, RailStationsCityName, RailStationsCode, RailStationsCountryName, RailStationsIata, RailStationsLongitude, RailStationsLatitude, RailStationsTimeZoneRegionName, RailStationsUtcOffsetHours, RailStationsIsDeleted, RailStationsSuppliers],
  routeParamId: 'railStationId',
  endpoint: 'RailStations'
};

const RailStationsList = {
  rootNode: true,
  displayName: 'Rail Stations',
  endpoint: 'RailStations',
  iconClass: 'fa-train',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: RailStationsResource,
  gridAdd: RailStationsAddResource,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'CityName', key: 'CityName'}]
};

export default {
  RailStationsList,
  RailStationsResource,
  RailStationsAddResource,
  RailStationsNameLabel,
  RailStationsId,
  RailStationsName,
  RailStationsCityCode,
  RailStationsCityLatitude,
  RailStationsCityLongitude,
  RailStationsCityName,
  RailStationsCode,
  RailStationsCountryName,
  RailStationsIata,
  RailStationsLongitude,
  RailStationsLatitude,
  RailStationsTimeZoneRegionName,
  RailStationsUtcOffsetHours,
  RailStationsIsDeleted,
  RailStationsSuppliers,
  RailStationsSuppliersItem,
  RailStationsSuppliersSupplier,
  RailStationsSuppliersCode
}



// WEBPACK FOOTER //
// ./src/config/fields/railStations.js